const rowStatuses = [
  "available",
  "scheduled",
  "held_complaint",
  "processing",
  "transferred",
  "applied_to_wallet",
  "failed",
];

function translate(vm, group, value) {
  if (value === null || value === undefined || value === "") return "-";
  const raw = String(value).trim();
  const key = `payouts.${group}.${raw}`;
  if (vm.$te(key)) return vm.$t(key);
  return raw;
}

export default {
  rowStatuses,
  purpose(vm, value) {
    return translate(vm, "purposes", value);
  },
  status(vm, value) {
    return translate(vm, "statuses", value);
  },
  part(vm, value) {
    return translate(vm, "parts", value);
  },
  reason(vm, value) {
    return translate(vm, "reasons", value);
  },
  currency(vm, value) {
    return translate(vm, "currencies", value);
  },
  transferMode(vm, value) {
    return translate(vm, "transferModes", value);
  },
  fieldValue(vm, key, value) {
    if (key === "purpose") return translate(vm, "purposes", value);
    if (key === "status" || key === "release_status") return translate(vm, "statuses", value);
    if (key === "part" || key === "covered_by") return translate(vm, "parts", value);
    if (key === "applied_reason") return translate(vm, "reasons", value);
    if (key === "currency") return translate(vm, "currencies", value);
    if (key === "transferMode") return translate(vm, "transferModes", value);
    if (key === "description") return translate(vm, "descriptions", value);
    if (key === "responseMessage") return translate(vm, "responseMessages", value);
    if (value === null || value === undefined || value === "") return "-";
    if (key === "hold_percent") {
      const raw = String(value).trim();
      return raw.endsWith("%") ? raw : `${raw}%`;
    }
    return String(value);
  },
  statusClass(status) {
    return {
      "text-danger font-weight-bold": status === "held_complaint" || status === "failed",
      "text-warning font-weight-bold":
        status === "processing" || status === "applied_to_wallet" || status === "scheduled",
      "text-success font-weight-bold": status === "transferred",
    };
  },
  canCancel(row) {
    if (!row || !row.payoutId) return false;
    if (row.transferMode === "INSTANT") return false;
    const code = row.responseCode === null || row.responseCode === undefined
      ? ""
      : String(row.responseCode);
    return code !== "00000" && code !== "77000";
  },
};
